import React from 'react';
import { Link } from 'react-router-dom';
import { Play, Music } from 'lucide-react';
import { useSite } from '@/context/SiteContext';

const MusicPlayer = () => {
  const { playlists } = useSite();

  if (playlists.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
          <Music className="h-8 w-8 text-muted-foreground" />
        </div>
        <p className="text-muted-foreground">No music available yet.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {playlists.map((playlist) => (
        <Link
          key={playlist.id}
          to={`/playlist/${playlist.id}`}
          className="group text-left focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background rounded-xl"
          data-testid={`playlist-card-${playlist.id}`}
        >
          {/* Album Cover */}
          <div className="relative aspect-square rounded-xl overflow-hidden bg-muted shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-[1.02]">
            {playlist.cover_image ? (
              <img 
                src={playlist.cover_image} 
                alt={playlist.title}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-muted to-muted-foreground/20">
                <Music className="h-12 w-12 text-muted-foreground" />
              </div>
            )}
            
            {/* Hover Overlay with Play Button */}
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
              <div className="w-14 h-14 rounded-full bg-foreground flex items-center justify-center shadow-lg transform scale-90 group-hover:scale-100 transition-transform">
                <Play className="h-6 w-6 text-background ml-1" />
              </div>
            </div>
          </div>

          {/* Album Info */}
          <div className="mt-3 px-1">
            <h3 className="font-medium truncate group-hover:text-foreground transition-colors">
              {playlist.title}
            </h3>
            <p className="text-sm text-muted-foreground truncate">
              {playlist.tracks?.length || 0} tracks
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default MusicPlayer;
